module.exports = __webpack_public_path__ + "assets/4884e457a9f55da6ea8f60f9e1c5bfd5.mp3";